import { render, staticRenderFns } from "./ParticipantsModal.vue?vue&type=template&id=aabb3b52&scoped=true&"
import script from "./ParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./ParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsModal.vue?vue&type=style&index=0&id=aabb3b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabb3b52",
  null
  
)

export default component.exports